import tokeys from "tokeys";

export default tokeys([
  "GET_APP_CONFIG",
  "GET_APP_FRONTPAGE",
  "GET_WORKSPACES",
  "CHANGE_APP_LANGUAGE",
  "PUSH_NOTIFICATION_TOKEN",
]);
